<template>
  <v-card flat>
    <v-flex xs12 v-if="isYoutube" style="margin-bottom:16px;">
      <youtube v-if="isYoutube" width="100%" :video-id="youtubeId" :resize=true></youtube>
    </v-flex>
    <v-flex xs12 v-if="isTwitter" style="margin-bottom:16px;">
      <Tweet :id="tweetId"></Tweet>
    </v-flex>
  </v-card>
</template>

<script>
import {Tweet} from 'vue-tweet-embed'

export default {
  name: 'SnsCard',
  data () {
    return {
      isYoutube: false,
      youtubeId: '',
      isTwitter: false,
      tweetId: ''
    }
  },
  props: {
    url: String
  },
  computed: {
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  created () {
  },
  mounted () {
    // youtube対応
    let url = this.url
    let p1 = 'https://www.youtube.com/watch?v='
    let p2 = 'https://youtu.be/'
    if (url.indexOf(p1) !== -1) {
      let id = url.split('v=')[1]
      this.isYoutube = true
      this.youtubeId = id
    } else if (url.indexOf(p2) !== -1) {
      let id = url.split('be/')[1]
      this.isYoutube = true
      this.youtubeId = id
    }
    // Twitter対応
    url = this.url
    p1 = 'https://twitter.com/'
    if (url.indexOf(p1) !== -1) {
      let id = url.split('/status/')[1]
      this.isTwitter = true
      this.tweetId = id
    }
  },
  methods: {
  },
  components: {
    Tweet
  }
}
</script>

<style>
</style>